import { useState } from "react";
import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Panel, Empty } from "@/components/PageHeader";
import { eur } from "@/lib/api";
import { downloadCsv, nfmt, pctFmt } from "@/lib/csv";

export const METRICS = { pct_receipts: ["% scontrini con prodotti volantino", (v) => `${nfmt(v, 2)}%`], pieces_100: ["Pezzi ogni 100 scontrini", (v) => nfmt(v, 1)],
  revenue_receipt: ["Incasso promo per scontrino con promo", (v) => eur(v)] };

export const classify = (stores, chain, metric, thr) => {
  const avg = chain[metric] || 0;
  const none = stores.filter((s) => s.receipts_total > 0 && !s.pieces);
  const sells = stores.filter((s) => s.pieces > 0);
  return { avg, none, below: sells.filter((s) => s[metric] < avg * (1 - thr / 100)), above: sells.filter((s) => s[metric] >= avg), all: stores };
};

const TABS = [["below", "Sotto media"], ["none", "Non vendono"], ["above", "Sopra media"], ["all", "Tutte"]];

export const StoreTable = ({ groups, metric, name }) => {
  const [tab, setTab] = useState("below");
  const [label, fmt] = METRICS[metric];
  const rows = groups[tab];
  const gap = (s) => (groups.avg ? ((s[metric] - groups.avg) / groups.avg) * 100 : null);
  const csv = () => downloadCsv(`sedi-${tab}-${name}`, ["Codice", "Punto vendita", "Scontrini totali", "Scontrini con volantino", "% scontrini", "Pezzi", "Pezzi ogni 100 scontrini", "Incasso promo", "Incasso promo per scontrino", `Scostamento da media (${label}) %`],
    rows.map((s) => [s.id, s.name, s.receipts_total, s.flyer_receipts, s.pct_receipts, s.pieces, s.pieces_100, s.revenue, s.revenue_receipt, gap(s)?.toFixed(1)]));
  return (
    <Panel testId="flyer-stores-table" title={<span>Punti vendita vs media catena <span className="ml-2 text-xs font-normal text-slate-400" data-testid="flyer-chain-avg">media {label.toLowerCase()}: {fmt(groups.avg)}</span></span>}
      action={<div className="flex flex-wrap items-center gap-2"><div className="flex gap-1 rounded-lg bg-slate-100 p-1">{TABS.map(([k, l]) => (
        <button key={k} data-testid={`flyer-stores-tab-${k}`} onClick={() => setTab(k)} className={`rounded-md px-2.5 py-1 text-xs ${tab === k ? "bg-white shadow-sm" : "text-slate-500"}`}>{l} ({groups[k].length})</button>))}</div>
        <Button size="sm" variant="ghost" data-testid="flyer-stores-csv" onClick={csv}><Download className="mr-1 h-4 w-4" />CSV</Button></div>}>
      {!rows.length ? <Empty text="Nessun punto vendita in questo gruppo" /> : (
        <div className="max-h-[520px] overflow-auto">
          <table className="w-full min-w-[860px] text-sm">
            <thead className="sticky top-0 bg-white"><tr className="text-left text-[11px] uppercase tracking-wider text-slate-400">
              <th className="px-5 py-2.5 font-medium">Punto vendita</th><th className="px-2 py-2.5 text-right font-medium">Scontrini</th><th className="px-2 py-2.5 text-right font-medium">Con volantino</th>
              <th className="px-2 py-2.5 text-right font-medium">Pezzi</th><th className="px-2 py-2.5 text-right font-medium">Incasso promo</th><th className="px-2 py-2.5 text-right font-medium">{label}</th>
              <th className="px-5 py-2.5 text-right font-medium">vs media</th></tr></thead>
            <tbody>{[...rows].sort((a, b) => a[metric] - b[metric] || b.receipts_total - a.receipts_total).map((s) => (
              <tr key={s.name} className="border-t border-slate-100" data-testid="flyer-store-row">
                <td className="max-w-[320px] truncate px-5 py-2 text-slate-800" title={s.name}>{s.name}</td>
                <td className="px-2 py-2 text-right tabular-nums">{nfmt(s.receipts_total, 0)}</td>
                <td className="px-2 py-2 text-right tabular-nums">{nfmt(s.flyer_receipts, 0)}</td>
                <td className="px-2 py-2 text-right tabular-nums">{nfmt(s.pieces)}</td>
                <td className="px-2 py-2 text-right tabular-nums">{eur(s.revenue)}</td>
                <td className="px-2 py-2 text-right font-medium tabular-nums">{fmt(s[metric])}</td>
                <td className={`px-5 py-2 text-right tabular-nums ${gap(s) === null ? "" : gap(s) < 0 ? "text-rose-600" : "text-emerald-600"}`}>{pctFmt(gap(s))}</td>
              </tr>))}</tbody>
          </table>
        </div>)}
    </Panel>
  );
};
